// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect, useRef } from 'react';
import { Platform, Pressable, type PressableProps, type View } from 'react-native';

/**
 * A button that says what it does when the mouse rests on it.
 *
 * On web the help is the element's own `title`, so the browser shows it after its usual pause
 * and takes it away again — no timer, no overlay to position, nothing a scrolling card can clip.
 * react-native-web does not forward a `title` prop, which is why it is set on the node itself.
 * Elsewhere there is no pointer to hover with; the same sentence is the accessibility hint.
 */
export function HelpPressable({ help, ...props }: PressableProps & { help: string }) {
  const ref = useRef<View>(null);

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    (ref.current as unknown as HTMLElement | null)?.setAttribute?.('title', help);
  }, [help]);

  return <Pressable ref={ref} accessibilityHint={help} {...props} />;
}
